import { fork } from 'redux-saga/effects';
import setTable2 from './setTable2';
import setSituation2 from './setSituation2';
import setFirstPairCardTableFold2 from './setFirstPairCardTableFold2';
import setSecondPairCardTableFold2 from './setSecondPairCardTableFold2';

export default function* tableSaga() {
  yield fork(setTable2);
  yield fork(setSituation2);
  yield fork(setFirstPairCardTableFold2);
  yield fork(setSecondPairCardTableFold2);
}
